var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupnextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0C16.149 0 0 16.149 0 36C0 55.851 16.149 72 36 72C55.851 72 72 55.851 72 36C72 16.149 55.851 0 36 0ZM47.121 38.121L32.121 53.121C31.536 53.706 30.768 54 30 54C29.232 54 28.4639 53.706 27.8789 53.121C26.706 51.948 26.706 50.052 27.8789 48.879L40.758 36L27.879 23.121C26.7061 21.948 26.7061 20.052 27.879 18.879C29.052 17.7061 30.948 17.7061 32.121 18.879L47.121 33.8791C48.294 35.052 48.294 36.948 47.121 38.121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupnextArrow);
export default __webpack_public_path__ + "static/media/popupnextArrow.20aa5ffac9f3675f7d2d7c97ded8fb71.svg";
export { ForwardRef as ReactComponent };